import React from "react"
import BaseIcon from "./BaseIcon"

const PlusIcon = ({ color, ...props}) => (
    <BaseIcon
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.8246 10.9306V10.8252L17.7194 10.8308C15.742 10.9348 13.8671 10.9878 11.9942 10.9896C12.0211 9.11576 12.0741 7.24044 12.1782 5.26307L12.1837 5.15781H12.0783H10.9119H10.8065L10.8121 5.26307C10.9161 7.24044 10.9691 9.11576 10.9961 10.9896C9.12313 10.9878 7.24823 10.9348 5.27088 10.8308L5.16562 10.8252V10.9306V12.0705V12.1759L5.27088 12.1704C7.24776 12.0663 9.12264 12.0133 10.996 11.9864C10.9691 13.8607 10.9161 15.7612 10.8121 17.7381L10.8065 17.8433H10.9119H12.0783H12.1837L12.1782 17.7381C12.0741 15.7612 12.0212 13.8607 11.9942 11.9864C13.8676 12.0133 15.7425 12.0663 17.7194 12.1704L17.8246 12.1759V12.0705V10.9306Z"
            fill={color ? color : "#0E0E0E"}
            stroke={color ? color : "#0E0E0E"}
            strokeWidth="0.2"
        />
        <circle
            cx="11.5"
            cy="11.5"
            r="10.25"
            stroke={color ? color : "#0E0E0E"}
            strokeWidth="1.5"
        />
    </BaseIcon>
)

export default PlusIcon
